module.exports = {"update-required-data":{"text":"Antes de continuar, preencha as seguintes informações:","save":"Atualizar dados","contact-chat":"Se você não souber seu número de empregado, por favor entre em contato com o chat de suporte técnico para obter ajuda.","messages":{"dni-already-exists":"Já existe um usuário cadastrado com esse documento de identidade","user-is-underage":"Você deve ser maior de idade para se registrar"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/public/views/account/update-required-data.json
// module id = 630
// module chunks = 120